// extracted by mini-css-extract-plugin
module.exports = {"providerImage":"styles_providerImage__tz9KP"};